import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SectionContainer = styled.section`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 4px 4px 0 rgba(0, 0, 0, 0.25);
  margin-bottom: 1.25rem;
  width: 100%;
`;

export const InvoiceOuter = styled.div`
  padding: 10px;
`;

export const HeaderTitle = styled.h2`
  color: ${(props) => props.color ?? "#00aeea"};
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  margin: ${(props) => props.margin ?? "0px"};
  justify-self: auto;
  font-weight: 700;
`;

export const CompanyInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  margin-bottom: 5px;
`;

export const InvoiceNumber = styled.span`
  color: #767676;
  font-weight: ${(props) => props.fontWeight ?? "700"};
  font-size: 14px;
  line-height: 1.25rem;
  margin-left: ${(props) => props.marginLeft ?? "1.25rem"};
`;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  > div {
    margin-right: 1rem;
  }
`;
